import { render } from "./ServiceDetailsPage.vue?vue&type=template&id=8c2a4370&ts=true"
import script from "./ServiceDetailsPage.vue?vue&type=script&lang=ts"
export * from "./ServiceDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__